import { useUserStore } from "@/stores/user";

export function commissionsEnabledGuard(to, from, next) {
  const user = useUserStore();
  if (user.loginable.hide_commission) {
    return next({ name: "Home" });
  }
  next();
}
